import { SelectedCoinDenom } from '@/wallet-utils'
import { queryKeys } from '@/query-keys'
import { useQuery } from '@tanstack/react-query'
import { redis } from '@/redis'
import { useSelectedChain } from '@/contexts/wallet'
import { useSelectedDenom } from '../../../contexts/denom'

const mapping: Partial<Record<SelectedCoinDenom, string>> = {
  ATOM: 'GAIA'
}

interface LsmValidatorPersonaQueryParameters {
  address?: string
}

interface LsmValidatorPersona {
  name: string
  logo: string
}

// @TODO: Make it so query cache is never garbage collected
const useLsmValidatorPersonaQuery = ({ address }: LsmValidatorPersonaQueryParameters) => {
  const [denom] = useSelectedDenom()

  const { address: selectedAddress } = useSelectedChain()

  const queryFn = async (): Promise<LsmValidatorPersona> => {
    const key = mapping[denom] ?? denom

    const [name, logo] = await Promise.all([
      // sheet_GAIA_LSM_ID_cosmos1c4k24jzduc365kywrsvf5ujz4ya6mwymy8vq4q
      redis.get<string>(`sheet_${key}_VALIDATORS_ID_${address}`),
      // sheet_GAIA_LSM_LOGO_cosmos1c4k24jzduc365kywrsvf5ujz4ya6mwymy8vq4q
      redis.get<string>(`sheet_${key}_VALIDATORS_LOGO_${address}`)
    ])

    return { name: name ?? '', logo: logo ?? '' }
  }

  return useQuery({
    queryKey: queryKeys.lsmValidatorPersonaByAddress({ address: address ?? '' }),
    queryFn,
    enabled: Boolean(selectedAddress && address)
  })
}

export { useLsmValidatorPersonaQuery }
